module.exports = __webpack_public_path__ + "static/img/14010111.2377d501.png";